import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SportEventV2OverviewPageFragmentDoc } from '../fragments/SportEventV2OverviewPage.fragment';
import { MultiStepSportEventFragmentDoc } from '../fragments/MultiStepSportEvent.fragment';
export type GetMultiStepSportOverviewQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	first: Types.Scalars['Int']['input'];
	bucketSize?: Types.InputMaybe<Types.Scalars['Int']['input']>;
	filter?: Types.InputMaybe<Types.SportEventFilter>;
	withOffers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	groupBy: Types.SportEventAggregation;
	platform: Types.Platform;
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	timezoneOffset: Types.Scalars['Int']['input'];
	sortBy?: Types.SportEventSorting;
	sortOrder?: Types.SortOrder;
}>;

export type GetMultiStepSportOverviewQuery = {
	__typename?: 'Query';
	sportEventBucketsV2: {
		__typename?: 'SportEventBucketsConnectionV2';
		edges?: Array<{
			__typename?: 'SportEventBucketsEdgeV2';
			key: {
				__typename?: 'SportEventAggregationKeyV2';
				parent?:
					| {
							__typename?: 'MultiStepSportEvent';
							competition?: {
								__typename?: 'SportCompetitionV2';
								content: {
									__typename?: 'SportCompetitionContentV2';
									fullPath: string;
									iconUrl?: string | null;
									name: string;
								};
							} | null;
					  }
					| {
							__typename?: 'SingleStepSportEvent';
							competition?: {
								__typename?: 'SportCompetitionV2';
								content: {
									__typename?: 'SportCompetitionContentV2';
									fullPath: string;
									iconUrl?: string | null;
									name: string;
								};
							} | null;
					  }
					| null;
				competitionStage?: {
					__typename?: 'SportCompetitionStageV2';
					name: Types.SportCompetitionStageName;
					number?: number | null;
				} | null;
				competition?: {
					__typename?: 'SportCompetitionV2';
					id: string;
					sport: Types.SportType;
					content: {
						__typename?: 'SportCompetitionContentV2';
						name: string;
						fullPath: string;
						iconUrl?: string | null;
					};
				} | null;
				sport?: { __typename?: 'Sport'; type: Types.SportType } | null;
			};
			node: {
				__typename?: 'SportEventsConnectionV2';
				totalCount: number;
				edges?: Array<{
					__typename?: 'SportEventsEdgeV2';
					cursor: string;
					node:
						| {
								__typename: 'MultiStepSportEvent';
								sport: Types.SportType;
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								offerCount: number;
								content: {
									__typename?: 'MultiStepSportEventContent';
									status: Types.SportEventStatus;
									startAt: any;
									season?: { __typename?: 'SportSeason'; name: string } | null;
									competitionStage: {
										__typename?: 'SportCompetitionStageV2';
										name: Types.SportCompetitionStageName;
										number?: number | null;
									};
								};
								competition?: {
									__typename?: 'SportCompetitionV2';
									id: string;
									objectType: Types.ObjectType;
									objectId: number;
									sport: Types.SportType;
									activeSeason?: {
										__typename?: 'SportSeason';
										name: string;
										seasonID: number;
									} | null;
									content: {
										__typename?: 'SportCompetitionContentV2';
										name: string;
										fullPath: string;
									};
								} | null;
								mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								children: Array<{
									__typename?: 'MultiStepSportEvent';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									offerCount: number;
									content: {
										__typename?: 'MultiStepSportEventContent';
										name: string;
										startAt: any;
										endAt?: any | null;
										status: Types.SportEventStatus;
										venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
										competitionStage: {
											__typename?: 'SportCompetitionStageV2';
											name: Types.SportCompetitionStageName;
											number?: number | null;
										};
									};
									watchNowOffer?: {
										__typename?: 'SportOffer';
										monetizationType: Types.MonetizationType;
										presentationType: Types.PresentationType;
										audioLanguage?: string | null;
										standardWebURL?: string | null;
										sportObjectType: Types.SportObjectType;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											technicalName: string;
											clearName: string;
											shortName: string;
											monetizationTypes: Array<Types.MonetizationType>;
											iconWide: string;
										};
									} | null;
									offers?: Array<{
										__typename?: 'SportOffer';
										monetizationType: Types.MonetizationType;
										presentationType: Types.PresentationType;
										audioLanguage?: string | null;
										standardWebURL?: string | null;
										sportObjectType: Types.SportObjectType;
										package: {
											__typename?: 'Package';
											id: string;
											packageId: number;
											technicalName: string;
											clearName: string;
											shortName: string;
											monetizationTypes: Array<Types.MonetizationType>;
										};
									}>;
								}>;
								watchNowOffer?: {
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
										iconWide: string;
									};
								} | null;
								offers?: Array<{
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
									};
								}>;
								parent?: {
									__typename?: 'MultiStepSportEvent';
									id: string;
									content: {
										__typename?: 'MultiStepSportEventContent';
										name: string;
										fullPath?: string | null;
										startAt: any;
										status: Types.SportEventStatus;
									};
								} | null;
						  }
						| {
								__typename?: 'SingleStepSportEvent';
								sport: Types.SportType;
								offerCount: number;
								watchNowOffer?: {
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
										iconWide: string;
									};
								} | null;
								offers?: Array<{
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
									};
								}>;
						  };
				}> | null;
				pageInfo: {
					__typename?: 'PageInfo';
					startCursor: string;
					endCursor: string;
					hasPreviousPage: boolean;
					hasNextPage: boolean;
				};
			};
		}> | null;
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
	};
};

export const GetMultiStepSportOverviewDocument = gql`
	query GetMultiStepSportOverview(
		$country: Country!
		$language: Language!
		$first: Int!
		$bucketSize: Int
		$filter: SportEventFilter
		$withOffers: Boolean = true
		$groupBy: SportEventAggregation!
		$platform: Platform!
		$after: String
		$timezoneOffset: Int!
		$sortBy: SportEventSorting! = START_AT
		$sortOrder: SortOrder! = ASC
	) {
		...SportEventV2OverviewPage
		sportEventBucketsV2(
			country: $country
			first: $first
			bucketSize: $bucketSize
			filter: $filter
			groupBy: $groupBy
			after: $after
			timezoneOffset: $timezoneOffset
			sortBy: $sortBy
			sortOrder: $sortOrder
		) {
			edges {
				key {
					parent {
						competition {
							content(country: $country, language: $language) {
								fullPath
								iconUrl
								name
							}
						}
					}
				}
				node {
					edges {
						node {
							...MultiStepSportEvent
						}
					}
				}
			}
		}
	}
	${SportEventV2OverviewPageFragmentDoc}
	${MultiStepSportEventFragmentDoc}
`;
